/* eslint-disable max-params */
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { CommandContribution, CommandRegistry } from '@patsnap/tahiti-core';
import { Message } from '@patsnap/tahiti-core';
import { CurrentTaskService } from '@/services/current-task/current-task-service';
import { I18nService } from '@telecom/shared/services/i18n';
import { GlossaryService, type Glossary } from '../glossary-service';
import { RequestGlossaryService } from '../request-glossary-service';

export const GLOSSARY_COMMAND_ID = 'glossary:open';

@injectable()
export class GlossaryCommandContribution implements CommandContribution {
    constructor(
        @inject(Message)
        private readonly _message: Message,
        @inject(CurrentTaskService)
        private readonly _currentTaskService: CurrentTaskService,
        @inject(I18nService)
        private readonly _i18nService: I18nService,
        @inject(RequestGlossaryService)
        private readonly _requestGlossaryService: RequestGlossaryService,
        @inject(GlossaryService)
        private readonly _glossaryService: GlossaryService,
    ) {}

    private async _handleGlossary(): Promise<void> {
        await this._requestGlossaryService.open();
    }

    registerCommands(commands: CommandRegistry): void {
        commands.registerCommand({
            id: GLOSSARY_COMMAND_ID,
        }, {
            execute: () => {
                this._handleGlossary();
            },
        });
    }
}

declare module '@patsnap/tahiti-core' {
    export interface CommandService {
        /**
         * 打开术语表对话框
         */
        executeCommand(commandId: typeof GLOSSARY_COMMAND_ID): Promise<Glossary>;
    }
}
